import { useContext } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { Titlebar, Navbar, Heading } from "@/common/components";

const ClosableLayout = ({ children }) => {
  const {
    navHeader,
    pageHeader,
    showChangeProductManufacturer,
    accessorDetails,
    productSponsorName,
    navCancelFunc,
    navCancelMessage,
    setNavCancelMessage,
    printRef,
  } = useContext(PrivateContext);

  return (
    <>
      <Titlebar
        wrapperClassName="closable-layout"
        layout="closableLayout"
        showChangeProductManufacturer={showChangeProductManufacturer}
        accessorDetails={accessorDetails}
        productSponsorName={productSponsorName}
      />
      <Navbar
        type="private"
        layout="closableLayout"
        navHeader={navHeader}
        navCancelFunc={navCancelFunc}
        navCancelMessage={navCancelMessage}
        setNavCancelMessage={setNavCancelMessage}
      />
      <main className="container" ref={printRef}>
        {pageHeader && (
          <Heading
            text={pageHeader}
            wrapperClassNames="h4 text-center pt-5 mb-0"
          />
        )}
        {children}
      </main>
    </>
  );
};

export default ClosableLayout;
